const isObjectEmpty = (obj: Record<string, any>) => {
  if (!obj) return false

  // @ts-ignore
  for (const key in obj) return false

  return true
}

const arrToKeyArray = <T extends Record<string, any>, Key extends keyof T>(
  items: T[],
  key: Key
): Record<T[Key], T[]> => {
  const itemsToMap: Record<T[Key], T[]> = {} as any

  for (const item of items) {
    if (Array.isArray(itemsToMap[item[key]])) {
      itemsToMap[item[key]].push(item)
    } else if (item[key]) {
      itemsToMap[item[key]] = [item] as any
    }
  }

  return itemsToMap
}

const arrToMap = <T extends Record<string, any>, Key extends keyof T>(items: T[], key: Key): Record<T[Key], T> => {
  const itemsToMap: Record<T[Key], T> = {} as any

  for (const item of items) {
    if (!itemsToMap[item[key]]) {
      itemsToMap[item[key]] = item
    }
  }

  return itemsToMap
}

const deepCopy = <T>(value: T): T => {
  if (!value) return value

  if (Array.isArray(value)) {
    return value.map((v) => deepCopy(v)) as any
  }

  if (typeof value === 'object') {
    const copy = { ...value }

    for (const [k, v] of Object.entries(value)) {
      copy[k] = deepCopy(v)
    }

    return copy
  }

  return value
}

const isJsonEqual = (a: any, b: any) => {
  let ta: string = typeof a
  let tb: string = typeof b

  if (a === null) ta = 'null'
  if (b === null) tb = 'null'
  if (Array.isArray(a)) ta = 'array'
  if (Array.isArray(b)) tb = 'array'

  if (ta !== tb) return false

  const isPrimitive = ta === 'number' || ta === 'string' || ta === 'undefined' || ta === 'null' || ta === 'boolean'
  if (isPrimitive) return a === b

  if (ta === 'array') {
    if (a.length !== b.length) return false
    return a.every((value, i) => isJsonEqual(value, b[i]))
  }

  // objects
  const keys1 = Object.keys(a)
  const keys2 = Object.keys(b)
  if (keys1.length !== keys2.length) return false

  return keys1.every((key) => isJsonEqual(a[key], b[key]))
}

const objectUtils = { isObjectEmpty, arrToKeyArray, arrToMap, deepCopy, isJsonEqual }
export default objectUtils
